import app from 'flarum/forum/app';
import {extend, override} from 'flarum/common/extend';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import UserSecurityPage from "flarum/forum/components/UserSecurityPage";
import LogInModal from 'flarum/forum/components/LogInModal';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import Button from 'flarum/components/Button';
import LinkButton from 'flarum/components/LinkButton';
import TextEditor from "flarum/components/TextEditor";

app.initializers.add('jtlab/user-interface-adaptation', () => {
  //remove the specific account section
  extend(SettingsPage.prototype, 'oncreate', function () {
    this.$('.Settings-account').remove();
  });

  //remove logout feature from security section
  extend(UserSecurityPage.prototype, 'oncreate', function () {
    this.$('.UserSecurityPage-globalLogout').remove();
  });

  //remove login-sign-in links for unauth users, add custom login link
  extend(HeaderSecondary.prototype, 'items', function (items) {
    items.remove('logIn');
    items.remove('signUp');

    if (!app.session.user) {
      items.add('login',
        LinkButton.component({
          onclick: (event) => {
            event.preventDefault();
            window.location.href = 'https://jt-lab.com/login?returnTo=' + window.location.href;
          },
          href: 'https://jt-lab.com/login?returnTo=' + window.location.href,
          className: 'Button Button--link',
        }, app.translator.trans('jtlab-user-interface-adaptation.forum.login'))
      );
    }
  });

  extend(HeaderPrimary.prototype, 'items', function (items) {
      items.add('main-page',
        LinkButton.component({
          href: 'https://jt-lab.com',
          target: '_blank',
          className: 'Button Button--link custom-menu-links',
        }, app.translator.trans('jtlab-user-interface-adaptation.forum.main_page'))
      );

    items.add('store-page',
      LinkButton.component({
        href: 'https://jt-lab.com/store',
        target: '_blank',
        className: 'Button Button--link custom-menu-links',
      }, app.translator.trans('jtlab-user-interface-adaptation.forum.store_page'))
    );

    items.add('account-page',
      LinkButton.component({
        href: 'https://jt-lab.com/dashboard',
        target: '_blank',
        className: 'Button Button--link custom-menu-links',
      }, app.translator.trans('jtlab-user-interface-adaptation.forum.account_page'))
    );

/*    items.add('signIn',
      LinkButton.component({
        onclick: (event) => {
          event.preventDefault();
          window.location.href = 'https://jt-lab.com/signup?returnTo=' + window.location.href;},
        href: 'https://jt-lab.com/signup?returnTo=' + window.location.href,
        className: 'Button Button--link',
      }, app.translator.trans('jtlab-user-interface-adaptation.forum.sign_in'))
    );*/

    });

  //override login modal to create own links for login and signin
  override(LogInModal.prototype, 'content', function (original) {

    const loginUrl = app.forum.attribute('loginUrl') + window.location.href;
    const signUpUrl = app.forum.attribute('signUpUrl') + window.location.href;
    const loginTranslation = app.translator.trans('jtlab-user-interface-adaptation.forum.login');
    const signUpTranslation = app.translator.trans('jtlab-user-interface-adaptation.forum.sign_in');

    return m('div', {className: 'LogInModal Modal--small'}, [
      m('div', {className: 'Form Form--centered'}, [
        m('p', [
          m(Button, {
            className: 'Button Button--primary jtlab-ui-login-btn',
            onclick: () => window.location.href = loginUrl
          }, loginTranslation)
        ]),
        m('p', [
          m(Button, {
            className: 'Button Button--primary jtlab-ui-login-btn',
            onclick: () => window.location.href = signUpUrl
          }, signUpTranslation)
        ])
      ])
    ]);

  });

  override(LogInModal.prototype, 'title', function () {
    return '';
  });

  extend(TextEditor.prototype, 'toolbarItems', function (items) {

    const toolbarButtons = items?._items?.markdown?.content?.children;

    if (toolbarButtons) {

      toolbarButtons.forEach(buttonProxy => {

        if (buttonProxy.attrs && (buttonProxy.attrs.title === 'Insert code')) {

          buttonProxy.attrs.onclick = () => {
            this.attrs.composer.editor.insertAtCursor('```typescript\n\n```');
            this.attrs.composer.editor.moveCursorTo(this.attrs.composer.editor.el.selectionStart - 4);
          };
        }
      });
    } else {
      console.error('Markdown toolbar item or its children are not found.');
    }
  });

}, -10);
